import { useState } from 'react';
import { SystemFormData } from '../../types';

export interface ValidationErrors {
  name: string;
  systemowner: string;
  department_id: string;
}

export const validateSystemForm = (
  formData: SystemFormData,
): ValidationErrors => {
  const errors: ValidationErrors = {
    name: '',
    systemowner: '',
    department_id: '',
  };

  if (!formData.name || formData.name.trim() === '') {
    errors.name = 'System name is required';
  }

  if (!formData.systemowner) {
    errors.systemowner = 'System owner is required';
  }

  if (!formData.department_id) {
    errors.department_id = 'Department is required';
  }

  return errors;
};

export const hasValidationErrors = (errors: ValidationErrors): boolean => {
  return !!(errors.name || errors.systemowner || errors.department_id);
};

export const useSystemValidation = () => {
  const [validationErrors, setValidationErrors] = useState<ValidationErrors>({
    name: '',
    systemowner: '',
    department_id: '',
  });

  const validateForm = (formData: SystemFormData): boolean => {
    const errors = validateSystemForm(formData);
    setValidationErrors(errors);
    return !hasValidationErrors(errors);
  };

  const clearValidationErrors = () => {
    setValidationErrors({
      name: '',
      systemowner: '',
      department_id: '',
    });
  };

  const clearFieldError = (field: keyof ValidationErrors) => {
    if (validationErrors[field]) {
      setValidationErrors({ ...validationErrors, [field]: '' });
    }
  };

  return {
    validationErrors,
    validateForm,
    clearValidationErrors,
    clearFieldError,
  };
};
